import React, { useEffect } from 'react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { setMetaTags } from '@/finsight/application/actions/metaTags/actions';
import NoAccessOverlay from '@/finsight/ui/common/components/NoAccessOverlay';
import MissingSomethingModalButton from '@/finsight/ui/common/components/MissingSomethingModalButton';
import PageHeaderWrapper from '@/finsight/ui/common/components/PageHeaderWrapper';
import LoanLevelHeader from './LoanLevelHeader';
import LoanLevelTable from './LoanLevelTable';
import LoanLevelPopover from './LoanLevelPopover';
import MetaSchema from '@/finsight/ui/common/components/MetaSchema';
import { useBreadcrumbsContext } from '@/finsight/ui/common/components/header/Breadcrumbs/BreadcrumbsContext';
import getLoanLevelMetaSchema from './getLoanLevelMetaSchema';
import getLoanLevelBreadcrumbs from './getLoanLevelBreadcrumbs';
import {
  loanLevelNoAccessDescription,
  loanLevelNoAccessFeatures,
  LOAN_LEVEL_PAGE_TITLE,
  loanLeveNoAccessImageCaption,
  loanLevelNoAccessTitle,
} from '@/finsight/ui/components/filings/constants';
import { UserPlanType } from '@/users/domain/UserPlan';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import metaTags from '@/finsight/ui/common/metaTagsConstants';
import image from '@/finsight/ui/assets/noAccess/loanLevelNoAccess.webp';

import aligns from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import styles from '@/finsight/ui/components/filings/LoanLevel/LoanLevelHeader/loanLevelHeader.scss';

const LoanLevel = () => {
  const dispatch = useDispatch();

  const { breadcrumbs, setBreadcrumbs } = useBreadcrumbsContext();

  useEffect(() => {
    dispatch(setMetaTags(metaTags.getLoanLevelData()));

    if (!breadcrumbs) {
      setBreadcrumbs(getLoanLevelBreadcrumbs());
    }

    return () => {
      setBreadcrumbs(null);
    };
  }, []);

  const pageTitle = (
    <div className={ aligns.flexSpaceBetween }>
      { LOAN_LEVEL_PAGE_TITLE }
      <LoanLevelPopover />
    </div>
  );

  return (
    <>
      <MetaSchema schema={ getLoanLevelMetaSchema() } />
      <PageHeaderWrapper title={ pageTitle } requiredUserPlan={ UserPlanType.STARTER } />
      <div className={ cn(cardStyles.cardContainer, styles.cardContainer) }>
        <CheckUserPlanAccess
          requiredUserPlan={ UserPlanType.STARTER }
          fallback={ (
            <NoAccessOverlay
              title={ loanLevelNoAccessTitle }
              features={ loanLevelNoAccessFeatures }
              description={ loanLevelNoAccessDescription }
              imageCaption={ loanLeveNoAccessImageCaption }
              image={ image }
              isLoginButton
              isDoubleImage
            />
          ) }
        >
          <LoanLevelHeader>
            <LoanLevelTable />
          </LoanLevelHeader>
        </CheckUserPlanAccess>
      </div>
      <MissingSomethingModalButton className={ cn(spacesStyles.ptm, spacesStyles.pbxl) } />
    </>
  );
};

export default LoanLevel;
